<style lang="scss">
.futures-table {
  td {
    text-align: center;
    padding: 0;

    &.first-column {
      text-align: left;
      padding-left: 3rem;
      width: 18%;
    }

    div {
      &.centered {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;

        &--row {
          flex-direction: row;
        }
      }
    }
  }

  tbody {
    tr:last-of-type {
      td {
        border-bottom-width: 0;
      }
    }
  }

  .flag-icon {
    width: 8rem;
    border-radius: 0.5rem;
  }

  .contract-column {
    width: calc(100vw / 7);
  }

  .contract {
    font-weight: bold;
    font-size: 4rem;
  }

  .br2 {
    border-right: 4px solid #dee2e6;
  }
}
</style>

<template>
  <v-home-slide
    :loading="loading"
  >
    <table
      v-if="hasData"
      class="futures-table table table--stripe h-full"
    >
      <tbody>
        <tr>
          <td
            class="first-column"
          />
          <td
            v-for="(exchange, index) in exchanges"
            :key="exchange"
            colspan="2"
            :class="{'br2': index + 1 < exchanges.length}"
          >
            <div class="centered centered--row">
              <img
                :src="flagAsset(exchange)"
                class="flag-icon mr-4"
              >
              <h1>{{ exchange }}</h1>
            </div>
          </td>
        </tr>
        <tr>
          <td />
          <td
            v-for="(contract, index) in contractsRowData"
            :key="index"
            class="contract-column"
            :class="{
              'br': [0,2,4].includes(index),
              'br2': [1, 3].includes(index)
            }"
          >
            <div class="centered contract">
              {{ contract }}
            </div>
          </td>
        </tr>
        <tr
          v-for="product in products"
          :key="product"
        >
          <td class="first-column">
            <div class="h-full flex flex-col justify-center">
              <h1>{{ product }}</h1>
            </div>
          </td>
          <future-cell
            v-for="(cellData, index) in productRowData(product)"
            :key="index"
            :data="cellData"
            :class="{
              'br': [0,2,4].includes(index),
              'br2': [1, 3].includes(index)
            }"
          />
        </tr>
      </tbody>
    </table>
  </v-home-slide>
</template>

<script>
import FutureCell from '@/views/Home/Futures/FutureCell';
import { flagAsset } from '@/helpers';
import { mapGetters } from 'vuex';

export default {
  name: 'Futures',
  components: {
    FutureCell,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      loadingFutures: 'loadingFutures',
      apiData: 'futureData',
    }),
    hasData() {
      return Object.keys(this.apiData).length > 0;
    },
    contracts() {
      return this.hasData
        ? this.apiData.contracts
        : [];
    },
    exchanges() {
      return this.hasData
        ? this.apiData.exchanges
        : [];
    },
    products() {
      return this.hasData
        ? this.apiData.products
        : [];
    },
    contractsRowData() {
      if (!this.hasData) {
        return [];
      }

      return this.exchanges.map(() => this.contracts).flat();
    },
  },
  watch: {
    loadingFutures() {
      this.loading = this.loadingFutures && !this.hasData;
    },
  },
  methods: {
    flagAsset,
    productRowData(product) {
      if (!this.hasData) {
        return [];
      }

      const rowData = [];
      this.exchanges.forEach((exchange) => {
        const exchangeData = this.apiData.data[product][exchange];

        this.contracts.forEach((contract) => {
          if (exchangeData === null) {
            rowData.push(null);
          } else {
            rowData.push(exchangeData[contract]);
          }
        });
      });

      return rowData;
    },
  },
};
</script>
